module.exports = __webpack_public_path__ + "media/images/flechedroite-b2bb4e1a3dc3c99b4042730830e70d97.png";